"use client";

import MainMenuList from "components/Layout/Sidebar/components/body/content/utils/menuList";
import { useUserStoreContext } from "context/userStore/userStore.provider";
import { useMemo } from "react";
import {
  buildPrimaryRailItems,
  buildTopLevelSidebarNav
} from "./build-sidebar-from-menu-list";
import type { SidebarMenuUser } from "./sidebar-menu-access";

export function useSidebarNavigation() {
  const { user } = useUserStoreContext((store) => ({ user: store.user }));

  const menuUser = useMemo<SidebarMenuUser>(
    () => ({
      systemRole: user?.systemRole,
      isi: user?.isi,
      jobyfineAdmin: user?.jobyfineAdmin,
      jobyfineRecruiter: user?.jobyfineRecruiter,
      jobyfineRequester: user?.jobyfineRequester
    }),
    [user]
  );

  // MainMenuList usa hooks: debe invocarse en el cuerpo del hook, no dentro de useMemo.
  const menuItems = MainMenuList();

  const topLevelNavItems = useMemo(
    () => buildTopLevelSidebarNav(menuItems, menuUser),
    [menuItems, menuUser]
  );

  const primaryRailItems = useMemo(
    () => buildPrimaryRailItems(topLevelNavItems),
    [topLevelNavItems]
  );

  return {
    topLevelNavItems,
    primaryRailItems
  };
}
